// GENERATED from the pipeline sources (classes-utility/*.{utilities,presets}.json) by
// styles/tools/pipeline/build-types.js — do not edit by hand. Edit a source and re-run
// `npm run build-types`.

// flex (utility)
export const FLEX_GAP = ['0', '1', '2', '3', '4', '6', '8', 'half', 'gutter'] as const;
export type FlexGap = typeof FLEX_GAP[number];

export const FLEX_ALIGN_ITEMS = ['start', 'end', 'center', 'stretch'] as const;
export type FlexAlignItems = typeof FLEX_ALIGN_ITEMS[number];

export const FLEX_ALIGN_SELF = ['auto', 'start', 'end', 'center', 'stretch'] as const;
export type FlexAlignSelf = typeof FLEX_ALIGN_SELF[number];

export const FLEX_DIRECTION = ['row', 'reverse', 'col', 'col-reverse'] as const;
export type FlexDirection = typeof FLEX_DIRECTION[number];

export const FLEX_JUSTIFY = ['start', 'end', 'center', 'between', 'around', 'evenly'] as const;
export type FlexJustify = typeof FLEX_JUSTIFY[number];

export const FLEX_ORDER = ['0', '1', '2', '3', '4', '5'] as const;
export type FlexOrder = typeof FLEX_ORDER[number];

export const FLEX_WIDTH = ['0', '10', '20', '25', '30', '40', '50', '60', '70', '75', '80', '90', '100', 'auto'] as const;
export type FlexWidth = typeof FLEX_WIDTH[number];

// button (preset)
export const BUTTON_VARIANT = ['filled', 'outlined', 'muted', 'transparent', 'loud', 'danger', 'danger-muted', 'light', 'dark', 'themed-outlined', 'link'] as const;
export type ButtonVariant = typeof BUTTON_VARIANT[number];

export const BUTTON_SIZE = ['mini', 'small', 'medium', 'large'] as const;
export type ButtonSize = typeof BUTTON_SIZE[number];

// text (preset)
export const TEXT_VARIANT_OPTIONS = {
  default: {
    sizes: ['350', '400'],
    weights: ['regular', 'bold'],
  },
  display: {
    sizes: ['1600'],
    weights: ['regular', 'bold'],
  },
  eyebrow: {
    sizes: ['300'],
    weights: ['regular', 'bold'],
  },
  fine: {
    sizes: ['300'],
    weights: ['regular', 'bold'],
  },
  title: {
    sizes: ['500', '600', '700', '800', '900', '1000', '1200'],
    weights: ['regular', 'bold'],
  },
  utility: {
    sizes: ['350', '400', '450', '500', '550', '600'],
    weights: ['regular', 'medium', 'semibold', 'bold'],
  },
} as const;

export const TEXT_VARIANT_DEFAULTS = {
  default: { size: '400', weight: 'regular' },
  display: { size: '1600', weight: 'bold' },
  eyebrow: { size: '300', weight: 'bold' },
  fine: { size: '300', weight: 'regular' },
  title: { size: '900', weight: 'bold' },
  utility: { size: '400', weight: 'regular' },
} as const;

// themed-surface (preset)
export const UTILITY_COLOR = ['info', 'loud', 'neutral', 'notice', 'success', 'urgent'] as const;
export type UtilityColor = typeof UTILITY_COLOR[number];

export const UTILITY_INTENSITY = ['transparent', 'ultralight', 'medium', 'bold'] as const;
export type UtilityIntensity = typeof UTILITY_INTENSITY[number];

export const SURFACE_VARIANT = ['primary', 'on-primary'] as const;
export type SurfaceVariant = typeof SURFACE_VARIANT[number];

export const THEME_BORDER = ['none', 'thin', 'leading-accent'] as const;
export type ThemeBorder = typeof THEME_BORDER[number];

export const TEMPO_THEME = ['vu-high', 'tweed-high', 'tweed-high-vu', 'teal-high', 'teal-high-kick', 'kick-high', 'kick-high-teal', 'yellow-high', 'yellow-high-vu', 'vu-mid', 'vu-mid-vu', 'vu-mid-dark', 'tweed-mid', 'tweed-mid-vu', 'teal-mid', 'teal-mid-kick', 'teal-mid-teal', 'teal-mid-dark', 'kick-mid-dark', 'neutral-vu', 'neutral-kick', 'neutral-teal'] as const;
export type TempoTheme = typeof TEMPO_THEME[number];
